// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3hpUQ","content":"RecentSearches_content__1Z5pi"};